import client from '../client'

export default {
  async getChains(params: { currency_id: string }): Promise<any[]> {
    const { data } = await client.get(`/currency/${params.currency_id}/chains`)
    return data
  },
}
